module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/home-358c07a3bd322172de1d946eb0402c60.svg";